import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/* Legacy route: redirect to the wizard's inline Add-on Details step. */
export default function ApplyAddOnDetails() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (loading) return;
    if (!user) { navigate(`/login?redirect=/apply/addons/${orderId}`); return; }
    api.get(`/orders/${orderId}`).then(({ data }) => {
      const n = data.num_applicants || 1;
      const lastIdx = n - 1;
      const hasAddOns = (data.add_ons || []).length > 0;
      navigate(
        hasAddOns
          ? `/apply/applicants/${orderId}/${lastIdx}?step=addons`
          : `/apply/review/${orderId}`,
        { replace: true }
      );
    }).catch(() => navigate("/dashboard", { replace: true }));
  }, [orderId, loading, user, navigate]);

  return null;
}
